import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ServiceOverlay from '../components/Overlay/ServiceOverlay';
import { setServiceActive } from '../actions';
import { linkPlaceholder } from '../lib/TranslationUtils';

class OverlayContainer extends Component {
  constructor(props) {
    super(props);

    // Reference to overlay element.
    this.setOverlayRef = ref => {
      this.overlayRef = ref;
    };

    // Bind click handlers.
    this.handleClick = this.handleClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active && !prevProps.active) {
      document.addEventListener('click', this.handleClick);
    } else if (!this.props.active && prevProps.active) {
      document.removeEventListener('click', this.handleClick);
    }
  }

  handleClick(e) {
    if (this.overlayRef && !this.overlayRef.contains(e.target)) {
      this.props.setServiceActive(false);
    }
  }

  handleCloseClick() {
    this.props.setServiceActive(false);
  }

  render() {
    const { active, content, country } = this.props;
    const { description, descriptionInlineLabel } = content.card;

    return (
      <div className={`overlay_container ${!active ? 'overlay_container--hidden' : ''}`}>
        {description && (
          <ServiceOverlay
            setRef={ref => {
              this.overlayRef = ref;
            }}
            country={country}
            active={active}
            content={content}
            description={linkPlaceholder(
              description,
              { SCHEDULE_INLINE_LINK: descriptionInlineLabel },
              '/support/tesla-app'
            )}
            link="/support/tesla-app"
            handleCloseClick={this.handleCloseClick}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.service,
    active: state.service.active,
    country: state.service.country,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setServiceActive: active => dispatch(setServiceActive(active)),
  };
};

OverlayContainer.defaultProps = {
  content: {},
  country: '',
};

OverlayContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object,
  active: PropTypes.bool.isRequired,
  country: PropTypes.string,
  setServiceActive: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverlayContainer);
